import { useLocation } from "react-router-dom";
import { isFranchisePortalSession } from "../../../utils/franchiseSession";
import { isPlanLockedPath } from "../../../utils/planLock";
import { PlanLockedScreen, usePlanAccess } from "./PlanAccess";
import "./PlanLocked.css";

export default function SubscriptionGate({ children }) {
  const location = useLocation();
  const { planExpired } = usePlanAccess();
  const franchisePortal = isFranchisePortalSession();

  if (!franchisePortal && planExpired && isPlanLockedPath(location.pathname)) {
    return <PlanLockedScreen />;
  }

  return children;
}
